import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertAction } from "@/components/AlertAction";
import { BadgeCheck } from "lucide-react";

const when = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export const GpApprovedAlert = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/greenpower/approvate-recenti").then((r) => setRows(r.data || [])).catch(() => {}); }, []);
  return rows.map((p) => (
    <div key={p.id} className="compact-actions rounded-xl border border-emerald-400/60 bg-emerald-50 dark:bg-emerald-950/30 px-3 py-2 flex items-center gap-2.5 min-h-[52px]" data-testid={`gp-approved-alert-${p.id}`}>
      <BadgeCheck className="w-4 h-4 text-emerald-600 shrink-0" />
      <p className="flex-1 min-w-0 text-xs sm:text-sm leading-snug line-clamp-2 sm:line-clamp-1" data-testid={`gp-approved-alert-text-${p.id}`}>
        <strong>Approvata la pratica di {p.cliente_nome || "un tuo cliente"}!</strong> Venergia ha approvato il contratto luce e gas n. {p.id_esterno} · {when(p.approved_at)}
      </p>
      <AlertAction to={`/app/richieste-energia?cerca=${encodeURIComponent(p.id_esterno || "")}`} testid={`gp-approved-alert-open-${p.id}`}>Vedi pratica</AlertAction>
    </div>
  ));
};
